const Breadcrumb = (pageSettings) => {
    if (!pageSettings) {
        return <></>;
    }

    if (!pageSettings.breadcrumbPath) {
        var locationParts = pageSettings.location.split('/');
        let breadcrumbPath = [];
        breadcrumbPath.push({
            name: 'Home',
            path: '/'
        });

        // from locationParts find the item which ends with link from navigation and add it to breadcrumbPath
        for (let i = 1; i < locationParts.length; i++) {
            let link = '/' + locationParts[i];
            let item = pageSettings.navigation.items.find((item) => item.link.endsWith(link));
            if (item) {
                breadcrumbPath.push({
                    name: item.text,
                    path: item.link
                });
            }
        }
        

        pageSettings.breadcrumbPath = breadcrumbPath;
    }

    return (
        <nav aria-label="breadcrumb" className="dfc-breadcrumb p-2 ps-3 mb-3">
            <ol className="breadcrumb m-0">
                {pageSettings.breadcrumbPath.map((item, index) => (
                    <li key={index} className={`breadcrumb-item ${index === pageSettings.breadcrumbPath.length - 1 ? 'active' : ''}`} aria-current={index === pageSettings.breadcrumbPath.length - 1 ? 'page' : undefined}>
                        {index === pageSettings.breadcrumbPath.length - 1 ? item.name : <a href={item.path}>{item.name}</a>}
                    </li>
                ))}
            </ol>
        </nav>
    );
}

export default Breadcrumb;